import React from 'react';
import { Play } from 'lucide-react';
import GameArtwork from '../../components/GameArtwork';
import { HOOKS, hook } from '../../lib/domHooks';

/**
 * Vega şemasının oyun kartı.
 *
 * Referans arayüzde kart **yalnızca görselden** oluşur: oyun adı ve
 * sağlayıcı kartın altında değil, üzerine gelince açılan koyu katmanda
 * görünür. Bu yüzden ad burada `title` olarak da yazılır — dokunmatik
 * cihazda üzerine gelme diye bir şey yok ve ekran okuyucunun okuyacağı tek
 * metin odur.
 *
 * İki varyantı vardır ve ikisi de referanstan gelir:
 *   * `variant="tile"` — kısayol şeridinin küçük kare kartı (ana sayfada
 *     hero'nun altındaki şerit): rozet ve ad katmanı taşımaz,
 *   * `variant="catalog"` — slot/canlı casino kataloğunun kartı: görselin
 *     **altında** adın kendi şeridi durur. Katalogda oyuncu adları tarayarak
 *     gezinir, bu yüzden ad orada gizlenmez.
 */
const VegaGameCard = ({ game, onPlay, variant = 'default' }) => {
  const play = () => onPlay?.(game);
  const keyPlay = (event) => { if (event.key === 'Enter') play(); };

  if (variant === 'tile') {
    return (
      <div
        {...hook(HOOKS.GAME_CARD)}
        className="vega-shortcut"
        onClick={play}
        onKeyDown={keyPlay}
        role="button"
        tabIndex={0}
        title={game.name}
      >
        <GameArtwork src={game.img || game.image} alt={game.name} />
      </div>
    );
  }

  return (
    <div
      className={`vega-card ${variant === 'catalog' ? 'is-catalog' : ''}`}
      onClick={play}
      onKeyDown={keyPlay}
      role="button"
      tabIndex={0}
      title={game.name}
    >
      <div className="vega-card-art">
        {/* Referansta kartın üstünde tek rozet durur: yeni oyunda "YENİ",
            değilse öne çıkan oyunda "POPÜLER". İkisi birden çizilseydi
            küçük kartın yarısı rozet olurdu. */}
        {game.new && <span className="vega-card-badge is-new">YENİ</span>}
        {!game.new && game.hot && <span className="vega-card-badge">POPÜLER</span>}
        <GameArtwork src={game.img || game.image} alt={game.name} />
        <span className="vega-card-hover">
          <span className="vega-card-play"><Play size={17} fill="currentColor" /></span>
          <span className="vega-card-name">{game.name}</span>
          {game.provider && <span className="vega-card-provider">{game.provider}</span>}
        </span>
      </div>
      {variant === 'catalog' && (
        <span className="vega-card-caption" title={game.name}>{game.name}</span>
      )}
    </div>
  );
};

export default VegaGameCard;
